<ion-content>
  <div class="flex-container-col">
    @if (newMediaModel.media) {
      <ion-toolbar class="menu-header__toolbar menu-header__toolbar--media-content">
        @if (!editMode) {
          <ion-buttons class="toolbar__start" slot="start">
            <ion-button fill="clear" (click)="onCloseMenu()" class="action-button">
              <span class="icon-chevron icon-chevron--left"></span>
            </ion-button>
            <h4 class="toolbar__title">{{ newMediaModel.media.title | truncate:10 }}</h4>
          </ion-buttons>
        }
        <ion-buttons slot="start">
          @if (formDirtyMode) {
            <ion-button
              (click)="cancelMenuUpdate()"
              class="menu-header__cancel-button action-button">
              <ion-label class="action-button__label">{{ 'media-menu.cancel' | translate }}</ion-label>
            </ion-button>
          }
        </ion-buttons>
        <ion-buttons slot="end">
          @if (formDirtyMode) {
            <ion-button
              (click)="doMenuUpdate()"
              class="menu-header__save-button action-button">
              <ion-label class="action-button__label">{{ 'media-menu.save' | translate }}</ion-label>
            </ion-button>
          }
          @if (!editMode) {
            <ion-button
              (click)="editMode=true"
              class="menu-header__edit-button action-button">
              <div class="action-button__icon label-icon icon-edit" aria-hidden="true"></div>
              <ion-label class="action-button__label">{{ 'media-menu.edit' | translate }}</ion-label>
            </ion-button>
          }
          @if (editMode && !formDirtyMode) {
            <ion-button
              (click)="onCloseMenu()"
              class="menu-header__close-button action-button">
              <span class="icon-exit" aria-hidden="true"></span>
            </ion-button>
          }
        </ion-buttons>
      </ion-toolbar>
    }
    @if (newMediaModel.media) {
      <div class="flex-container-row view-content"
            [ngClass]="{
                'media-content--edit-view': !editMode,
                'menu-content--edit-view': editMode
            }">
        <div class="media-content">
          @if (newMediaModel.media.type === 'Image') {
            <div class="image-content middle">
              @if (newMediaModel.media.signedDownloadUrl?.url) {
                <img style="object-fit: fill; height: auto; max-height: 100vh;" [src]="newMediaModel.media.signedDownloadUrl?.url" [alt]="'media-menu.image.description' | translate">
              }
            </div>
          } @else {
            <div class="video-content middle">
              @if (newMediaModel.media.signedDownloadUrl?.url) {
                <video controls disablePictureInPicture controlsList="nodownload" style="height: 100%; width: 100%;" [src]="newMediaModel.media.signedDownloadUrl?.url" #videoClip></video>
              }
            </div>
          }
        </div>
        <div class="menu-content">
          <ion-toolbar class="menu-header__toolbar menu-header__toolbar--menu-content">
            <ion-buttons slot="start">
              @if (formDirtyMode) {
                <ion-button
                  (click)="cancelMenuUpdate()"
                  class="menu-header__cancel-button action-button">
                  <ion-label class="action-button__label">{{ 'media-menu.cancel' | translate }}</ion-label>
                </ion-button>
              }
            </ion-buttons>
            <ion-buttons slot="end">
              @if (formDirtyMode) {
                <ion-button
                  (click)="doMenuUpdate()"
                  class="menu-header__save-button action-button">
                  <ion-label class="action-button__label">{{ 'media-menu.save' | translate }}</ion-label>
                </ion-button>
              }
              @if (!formDirtyMode) {
                <ion-button
                  (click)="onCloseMenu()"
                  class="menu-header__close-button action-button">
                  <span class="icon-exit" aria-hidden="true"></span>
                </ion-button>
              }
            </ion-buttons>
          </ion-toolbar>
          @if (newMediaModel) {
            <ion-list class="menu-container" (ionChange)="onMenuDirty()">
              <ion-item-group class="form-group">
                <ion-item lines="none">
                  <ion-input
                    class="textarea textarea--title"
                    [(ngModel)]="newMediaModel.media.title"
                    [placeholder]="'media-menu.title-placeholder' | translate"
                    maxlength="88">
                  </ion-input>
                </ion-item>
                <ion-item lines="none">
                  <textarea
                    (input)="onMenuDirty()"
                    class="textarea textarea--description"
                    [(ngModel)]="newMediaModel.media.description"
                    [placeholder]="'media-menu.description-placeholder' | translate"
                    maxlength="200">
                  </textarea>
                </ion-item>
              </ion-item-group>
              <ion-item-group class="form-group">
                <ion-item lines="none">
                  <ion-label>
                    {{ 'media-menu.tag-students.label' | translate }}
                  </ion-label>
                </ion-item>
                <ul class="student-list">
                  @for (student of newMediaModel.students; track trackByStudentId(i, student); let i = $index) {
                    <li class="student-list__item" lines="none">
                      <ion-checkbox mode="md" [(ngModel)]="student.selected" class="checkbox" slot="start">
                      </ion-checkbox>
                      <div class="list-item__container">
                        <ion-avatar class="avatar" [title]="student.initials">
                          <span class="avatar__initials">{{ student.initials }}</span>
                        </ion-avatar>
                        <ion-label class="list-item__label">{{ student.name }}</ion-label>
                      </div>
                    </li>
                  }
                </ul>
              </ion-item-group>
            </ion-list>
          }
        </div>
      </div>
    }
  </div>
</ion-content>
